/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_ColumnsInputs */

const cs_messages_columns = /** @type {(inputs: Messages_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sloupce`)
};

const en_messages_columns = /** @type {(inputs: Messages_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Columns`)
};

/**
* | output |
* | --- |
* | "Columns" |
*
* @param {Messages_ColumnsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_columns = /** @type {((inputs?: Messages_ColumnsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_ColumnsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_columns(inputs)
	return cs_messages_columns(inputs)
});